import React from 'react';
import CardCard from './CardCard';
import {useState, useEffect} from 'react';
//import {Buffer} from 'buffer';
import { Rings } from 'react-loader-spinner'

function CardsTable() {

  const [cards, setCards] = useState([]);
  const PROXY_URL = process.env.REACT_APP_PROXY_ENDPOINT
  const API_URL = process.env.REACT_APP_CARDLY_ENDPOINT
  const API_KEY = process.env.REACT_APP_CARDLY_KEY
  console.log("URL"+PROXY_URL+API_URL+API_KEY )

  const getCards= async(id) => {
 
      const response = await fetch(`${PROXY_URL}/${API_URL}art/${id}`, {
      method: 'GET',
      headers: {'Content-type': 'text/json','Authorization': 'API-Key ' + API_KEY} })
      //headers: {'Content-type': 'text/json','Authorization': 'API-Key test_b1fd7407a9343149a35238d007df5bea34a14aef'} })
    const data = await response.json();
    setCards(data);
  }
  
  useEffect(() => {
    getCards('');
  }, [])

  return (
    <div className="container-fluid py-4">
      <div className="row">
        <div className="col-12">
          <div className="card my-4">
            <div className="card-header p-0 position-relative mt-n4 mx-3 z-index-2">
              <div className="bg-gradient-primary shadow-primary border-radius-lg pt-4 pb-3">
                <h6 className="text-white text-capitalize ps-3">Cards table</h6>
              </div>
            </div>
            <div className="card-body px-0 pb-2">
              <div className="table-responsive p-0">

                  {cards?.length > 0 ?
                    (
                      <table className="table align-items-center mb-0">
                      <thead>
                        <tr>
                          <th className="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Card</th>
                          <th className="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 ps-2">Description</th>
                          <th className="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Tags</th>
                          <th className="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">id</th>
                          <th className="text-secondary opacity-7"></th>
                        </tr>
                      </thead>
                      <tbody>
                  
                      {cards.map ((card) => (
                        <CardCard card={card}/>
                      ))}
                      </tbody>
                      </table>
                    ) : (
                      <table className="table align-items-center mb-0">
                      <tbody><tr><td>
                      <Rings
                        visible={true}
                        height="80"
                        width="80"
                        color="#4fa94d"
                        ariaLabel="rings-loading"
                        wrapperStyle={{}}
                        wrapperClassName=""
                        />
                      </td></tr></tbody>
                      </table>
                    )
                  }

              </div>
            </div>
          </div>
        </div>
      </div>
    </div> 
  )
}


export default CardsTable;